import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import UserDetails from './submodules/userDetails';
import ListUserSegments from './submodules/listUserSegments';

const UpdateUserSegmentDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updateUserDetails]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/updateUserDetails`}
				component={UserDetails}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].listUserSegments]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/updateUserDetails/listUserSegments`}
				component={ListUserSegments}
				exact
			/>
			<Redirect to={`${path}/updateUserDetails`} />
		</Switch>
	);
};

export default UpdateUserSegmentDashboard;
